var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFugletaarnUdsigtstaarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#427c7f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.638,4.251,7.992,1.637a.336.336,0,0,0-.394,0L3.953,4.251a.2.2,0,0,0,.115.358h.457v9.014a.395.395,0,0,0,.789,0v-.63l2.394-1.437L10.277,13.1v.525a.395.395,0,0,0,.789,0V4.609h.457A.2.2,0,0,0,11.638,4.251ZM5.314,6.263V4.781a.172.172,0,0,1,.172-.172h2.05a.172.172,0,0,1,.172.172V6.263a.172.172,0,0,1-.172.172H5.486A.172.172,0,0,1,5.314,6.263Zm0,5.81V10.119l1.628.977Zm4.963.106L8.474,11.1l1.8-1.082Zm0-3.084L7.708,10.637,5.314,9.2V8.292h4.963Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFugletaarnUdsigtstaarn);
export default __webpack_public_path__ + "static/media/FUGLETAARN-UDSIGTSTAARN.3e871d100b8c4a90c76c5c6d47c5aed6.svg";
export { ForwardRef as ReactComponent };